"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'notificationsTV';
exports.SET_NOTIFICATION_COUNT = exports.namespace + "/SET_NOTIFICATION_COUNT";
exports.SET_NOTIFICATIONS_SEEN = exports.namespace + "/SET_NOTIFICATIONS_SEEN";
exports.TOAST_MESSAGE = exports.namespace + "/TOAST_MESSAGE";
exports.FILLED_TOAST_MESSAGE = exports.namespace + "/FILLED_TOAST_MESSAGE";
exports.SET_NOTIFICATION_MESSAGE = exports.namespace + "/SET_NOTIFICATION_MESSAGE";
//# sourceMappingURL=constants.js.map